RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.CustomerChangeRequests = Backbone.Collection.extend({
        model: Admin.models.CustomerChangeRequest,

        initialize: function (data, options) {
            const me = this;
            me.options = options;
        },

        url: function () {
            const me = this;
            return `/admin/api/companies/${me.options.companyId}/customerChangeRequests`;
        }
    });
});
